// MouseTooltip.js
import React from 'react';
import './MouseTooltip.css';

const MouseTooltip = () => {
  // Просто возвращаем div с классом "mouse", к которому применятся стили
  return <div className="mouse" />;
};

export default MouseTooltip;
